<ion-grid>
  <ion-row>
    <ion-col size="4" *ngFor="let note of notes">
      <ion-card color="light" class="my-item">
        <ion-card-header color="medium" class="header-class">
          <ion-text color="light" text-regular="" font-regular=""
            >Note •</ion-text
          >
          <ion-text color="light" text-regular="" font-bold="">
            {{ note.forExecutive ? "Executive" : "Order" }}</ion-text
          >
        </ion-card-header>
        <ion-card-content class="ion-no-padding">
          <ion-grid class="grid-content">
            <ion-row>
              <ion-col size="12">
                <ion-text color="medium" text-regular="">{{
                  note?.text
                }}</ion-text>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="6">
                <ion-row>
                  <ion-text
                    class="ion-text-uppercase letter-spacing"
                    color="medium"
                    text-small
                    font-bold=""
                    >Added by</ion-text
                  >
                </ion-row>
                <ion-row>
                  <ion-text text-regular="" class="padding-5" color="dark">{{
                    note?.createdBy
                  }}</ion-text>
                </ion-row>
              </ion-col>
              <ion-col size="6" class="column-class">
                <ion-text
                  text-small
                  color="medium"
                  font-bold=""
                  class="ion-float-right text-class"
                  >{{ note?.createdAt | date: "dd-MMM-yy hh:mm a" }}</ion-text
                >
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
